import { useState, useEffect } from 'react';
import { ExposurePanel, ExposureSummaryPanel, HowItWorks, api } from './_barrel.js';


        // Top-level Exposure section: pick a subject, then show their exposure.
        function ExposureView({ token, me, initialSubjectId }) {
            const [subjects, setSubjects] = useState(null);
            const [sel, setSel] = useState(initialSubjectId || '');
            const [err, setErr] = useState(null);
            useEffect(() => {
                let live = true;
                api('/api/v1/subjects?limit=200', {}, token)
                    .then(r => { if (live) setSubjects(r.items || []); })
                    .catch(e => { if (live) setErr(e.message); });
                return () => { live = false; };
            }, [token]);
            return (
                <div style={{ maxWidth: 960, margin: '0 auto' }}>
                    <div className="mb-6">
                        <div className="font-mono text-xs uppercase tracking-widest text-muted mb-1">Location Exposure</div>
                        <h1 className="font-display text-2xl gold">Adtech Exposure</h1>
                        <p className="text-sm text-muted mt-1" style={{ maxWidth: 640 }}>
                            What a hostile party could infer about a subject from the location history data
                            brokers buy and sell — inferred home, workplace, routine, and how predictable
                            their movements are. Strictly consent-gated.
                        </p>
                    </div>
                    <HowItWorks id="exposure" title="How to read location exposure"
                        intro="This shows what a hostile party could infer about a subject from the commercial location data brokers buy and sell — strictly consent-gated."
                        steps={[
                            "Pick a subject with recorded consent to load their exposure.",
                            "Read the inferred <b>home, workplace and routine</b>, and how predictable their movement is.",
                            "Use the findings to brief protective measures — nothing here is collected without consent.",
                        ]} />
                    <div className="panel p-4 mb-6 flex items-center gap-3 flex-wrap">
                        <span className="font-mono text-xs uppercase tracking-widest text-muted">Subject</span>
                        <select className="chip" style={{ minWidth: 220 }}
                                value={sel} onChange={e => setSel(e.target.value)}>
                            <option value="">Select a subject…</option>
                            {(subjects || []).map(s => (
                                <option key={s.id} value={s.id}>{s.display_name || s.full_name}</option>
                            ))}
                        </select>
                        {err && <span className="text-sm" style={{ color: 'var(--red)' }}>{err}</span>}
                    </div>
                    {sel
                        ? <>
                            <ExposureSummaryPanel subjectId={sel} token={token} />
                            <ExposurePanel subjectId={sel} token={token} me={me}
                                           subjectName={(() => { const x = (subjects || []).find(s => s.id === sel); return x && (x.display_name || x.full_name); })()} />
                          </>
                        : <div className="panel p-10 text-center text-muted text-sm">
                            Pick a subject above to see their location exposure — or to trial it by uploading
                            a location export (e.g. a Google Timeline file).
                        </div>}
                </div>
            );
        }

export { ExposureView };
